var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnHeightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7857 19.678H0.214286C0.0964286 19.678 0 19.7744 0 19.8923V21.4994C0 21.6173 0.0964286 21.7137 0.214286 21.7137H17.7857C17.9036 21.7137 18 21.6173 18 21.4994V19.8923C18 19.7744 17.9036 19.678 17.7857 19.678ZM17.7857 0.285156H0.214286C0.0964286 0.285156 0 0.381585 0 0.499442V2.10659C0 2.22444 0.0964286 2.32087 0.214286 2.32087H17.7857C17.9036 2.32087 18 2.22444 18 2.10659V0.499442C18 0.381585 17.9036 0.285156 17.7857 0.285156ZM11.6464 7.41016C11.8071 7.41016 11.8982 7.22266 11.7991 7.09676L9.09911 3.67891C9.08124 3.65578 9.05831 3.63705 9.03207 3.62417C9.00584 3.61129 8.977 3.60459 8.94777 3.60459C8.91854 3.60459 8.8897 3.61129 8.86347 3.62417C8.83723 3.63705 8.8143 3.65578 8.79643 3.67891L6.09643 7.09676C6.07393 7.12536 6.05995 7.15972 6.05608 7.19589C6.05221 7.23207 6.05861 7.26861 6.07454 7.30131C6.09048 7.33402 6.1153 7.36158 6.14618 7.38083C6.17705 7.40008 6.21272 7.41024 6.24911 7.41016H8.03572V14.5887H6.35357C6.19286 14.5887 6.10179 14.7762 6.20089 14.9021L8.90089 18.3173C8.97857 18.4164 9.12857 18.4164 9.20357 18.3173L11.9036 14.9021C12.0027 14.7762 11.9143 14.5887 11.7509 14.5887H9.96429V7.41016H11.6464Z",
    fill: "url(#paint0_linear_2682_3552)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2682_3552",
    x1: 0.607039,
    y1: -7.63413,
    x2: 19.436,
    y2: -7.14322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC165"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnHeightIcon);
export default __webpack_public_path__ + "static/media/column-height-icon.165c8498785733ebb68d93415ee15039.svg";
export { ForwardRef as ReactComponent };